var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildersConstructionLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 79,
    viewBox: "0 0 110 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07704 41.2223V58.3873L61.3024 57.5654L71.1619 78H84.3079C97.9767 77.5 101.014 73.6406 104.849 71.4609C111.977 65.5 107.587 62.1973 104.849 60.0176H97.4539V41.2223C95.4766 18.5 75.27 9.07337 67.0538 6.89219V32.2311C64.4246 34.8503 62.124 33.3224 61.3024 32.2311V2.80528C52.7575 -0.464254 46.2393 1.44297 44.0483 2.80528V32.2311C41.4191 34.8467 38.5708 33.3209 37.4753 32.2311V6.89219C15.4766 14 7.47656 30.5 7.07704 41.2223Z",
    fill: "#F85757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8394 72.2828H8.72029L2.14729 64.9264C-0.0232946 62.5 0.504035 58.3873 7.07704 58.3873M7.07704 58.3873V41.2223C7.47656 30.5 15.4766 14 37.4753 6.89219V32.2311C38.5708 33.3209 41.4191 34.8467 44.0483 32.2311V2.80528C46.2393 1.44297 52.7575 -0.464254 61.3024 2.80528V32.2311C62.124 33.3224 64.4246 34.8503 67.0538 32.2311V6.89219C75.27 9.07337 95.4766 18.5 97.4539 41.2223V60.0176H104.849C107.587 62.1973 111.977 65.5 104.849 71.4609C101.014 73.6406 97.9767 77.5 84.3079 78H71.1619L61.3024 57.5654L7.07704 58.3873Z",
    stroke: "#F85757",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildersConstructionLogo);
export default __webpack_public_path__ + "static/media/builders-construction-logo.70cc8a24132b5f9a01fe5b58eb6b0ff1.svg";
export { ForwardRef as ReactComponent };